import { render, staticRenderFns } from "./WfconsumerRecordUsualModal.vue?vue&type=template&id=0f8d035c&"
import script from "./WfconsumerRecordUsualModal.vue?vue&type=script&lang=js&"
export * from "./WfconsumerRecordUsualModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports